import React from 'react';
import styles from './Textarea.module.css';

const Textarea = (props) => (
    <textarea {...props} className={`${styles.textarea} ${props.styles}`}></textarea>
)

export default Textarea;